import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useCheckEditTemplatedCampaignPermission } from 'hooks/permissions'
import { CAMPAIGN_STATUS_ENUM } from 'state/campaigns'
import { selectCampaignByTemplateData } from 'state'
import qs from 'query-string'

type RestrictedProps = {
    checkForLiveEditBriefAndDeadline?: boolean
    statusesToShow?: CAMPAIGN_STATUS_ENUM[]
}

const EditTemplateRestricted: React.FC<RestrictedProps> = ({
    checkForLiveEditBriefAndDeadline = false,
    statusesToShow = [],
    children,
}) => {
    const params = qs.parse(location.search)
    const { templateData: templateDataUuid } = params
    const campaign = useSelector(selectCampaignByTemplateData)
    const isPermissionEditable = useCheckEditTemplatedCampaignPermission(
        (campaign && campaign.status) || undefined,
        checkForLiveEditBriefAndDeadline,
    )

    const showByStatus = useMemo(() => {
        const statusList = [CAMPAIGN_STATUS_ENUM.DRAFT, CAMPAIGN_STATUS_ENUM.FOR_EDIT]
        if (statusesToShow.length) {
            statusList.push(...statusesToShow)
        }

        return campaign?.status !== undefined && statusList.includes(campaign.status)
    }, [campaign?.status, statusesToShow])

    const isShow = !templateDataUuid ? true : isPermissionEditable && showByStatus

    if (isShow) {
        return <>{children}</>
    }

    return null
}

export default EditTemplateRestricted
